import { jsxs as k, jsx as r } from "@emotion/react/jsx-runtime";
import { useEffect as u } from "react";
import { StyledTr as x, StyledCheckboxContainer as b } from "./Row.styled.js";
import { Checkbox as d } from "../../../Checkbox/index.js";
import { Tooltip as g } from "../../../Tooltip/index.js";
import { useTableContext as w } from "../../TableContext.js";
import { Cell as R } from "../Cell/Cell.js";
const E = ({
  dataTrackId: c,
  children: a,
  className: i,
  id: e,
  selectDisabled: o,
  highlightAnimation: m,
  onClick: s
}) => {
  const {
    selectable: f,
    registerSelectableRow: t,
    selectedRowIds: n,
    selectRow: h,
    unselectRow: p
  } = w();
  u(() => {
    if (!o)
      return t(e);
  }, [e, t, o]);
  const C = () => {
    n[e] ? p(e) : h(e);
  };
  return /* @__PURE__ */ k(x, { className: i, "data-track": `row__${c}`, highlightAnimation: m, onClick: s, children: [
    f ? /* @__PURE__ */ r(R, { children: /* @__PURE__ */ r(b, { onClick: (l) => l.stopPropagation(), children: /* @__PURE__ */ r(g, { text: typeof o == "string" ? o : void 0, children: /* @__PURE__ */ r(d, { dataTrackId: "", name: "table-select-checkbox", "aria-label": "select", checked: n[e], value: e, onChange: C, disabled: o !== void 0 }) }) }) }) : null,
    a
  ] });
};
export {
  E as Row
};
